.bv{overflow:hidden;}